import { IconLoader } from '@tabler/icons-react';
import { VariantProps, cva } from 'class-variance-authority';

import { BaseUIComponentProps } from './base';

const loaderVariants = cva('', {
    variants: {
        size: {
            sm: 'h-4 w-4',
            md: 'h-6 w-6',
            lg: 'h-8 w-8',
        },
        mode: {
            light: 'text-neutral-200',
            dark: 'text-neutral-700',
        },
        spin: {
            true: 'animate-spin-slow',
            false: '',
        },
    },
    defaultVariants: {
        size: 'md',
        mode: 'light',
        spin: true,
    },
});

export const Loader = ({ mode, size, spin = true }: VariantProps<typeof loaderVariants> & BaseUIComponentProps) => {
    return (
        <div>
            <IconLoader className={loaderVariants({ mode, size, spin })} />
        </div>
    );
};
